import React from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../common/StyledToolTip";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer'
import styles from "../../../../layout/layoutHeader/components/styles";

const ShowDriverNames = ({ classes, ...props }) => {
  return (
    <Tooltip title="Enable/Disable Show Driver Label">
      <div className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${props.isMenuItem ? classes.toggleAnimationButtonMenu : ""}`}>
        <div className={classes.toggleText}>Show Driver Label</div>
        <ToggleRenderer
          value={props.isEnabled}
          onChange={props.toggleShowDriverLabel}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(ShowDriverNames);
